import { get } from '@web3/base-utils';
import {
  Chain,
  GetCoinInfoRes,
  GetCoinPriceRes,
  GetTokenBalanceParams,
  GetTokenBalanceResult,
  GetContractBalanceParams,
  GetContractBalanceRes,
  GetCoinInfoParams,
} from '@/types/wallet';
import { walletApiUrl, walletV1PrivateApiUrl } from '@/config/api';

export const getCoinInfo = (params: GetCoinInfoParams) => {
  return get<GetCoinInfoRes>(`${walletApiUrl}/coins/info`, {
    chainCode: params.chainCode,
    contractAddresses: params.contractAddresses.join(','),
  });
};

export const getCoinPrice = (params: GetCoinInfoParams) => {
  return get<GetCoinPriceRes>(`${walletApiUrl}/coins/usd/price`, {
    chainCode: params.chainCode,
    contractAddresses: params.contractAddresses.join(','),
  });
};

export const getContractBalance = (params: GetContractBalanceParams) => {
  return get<GetContractBalanceRes>(`${walletApiUrl}/contractBalance`, params);
};

export const getTokenBalance = (params: GetTokenBalanceParams) => {
  return get<GetTokenBalanceResult>(
    `${walletV1PrivateApiUrl}/mgmt/asset/query`,
    params,
    {
      useThirdConfig: true,
    }
  );
};

/** 获取链列表 */
export const queryChainList = () => {
  return get<{
    walletChains: {
      CLOUD: { itemList: Chain[] };
      MNEMONIC_PHRASE: { itemList: Chain[] };
    };
  }>(`${walletV1PrivateApiUrl}/mgmt/chain/list`);
};
